<template>
    
    <div class="main">
        <c-panel>
            <form-atividade-complementar :paramId="$route.params.id" v-on:onSubmitAtividadeComplementar="onSubmitAtividadeComplementar"></form-atividade-complementar>
        </c-panel>
    </div>
    
</template>
<script>

import formAtividadeComplementar from "./form"

export default {
    methods:{

        onSubmitAtividadeComplementar(){

            this.$router.push('/admin/atividade-complementar');  
        }
    },
    components:{ formAtividadeComplementar }
}
</script>
